// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.electric-root,
.chakra-portal {
    font-size: 14px;
}

.electric-root [class^='fa-'],
.electric-root [class*=' fa-'],
.chakra-portal [class^='fa-'],
.chakra-portal [class*=' fa-'] {
    margin: 0;
    font-size: inherit;
}

/* Add font awesome style that's missing in PC */
.electric-root .svg-inline--fa,
.chakra-portal .svg-inline--fa {
    box-sizing: content-box;
}

.electric-root table,
.electric-root th,
.electric-root tr,
.electric-root td,
.electric-root ul,
.electric-root ol,
.electric-root li,
.electric-root p,
.electric-root font,
.electric-root a,
.electric-root blockquote,
.chakra-portal table,
.chakra-portal th,
.chakra-portal tr,
.chakra-portal td,
.chakra-portal ul,
.chakra-portal ol,
.chakra-portal li,
.chakra-portal p,
.chakra-portal font,
.chakra-portal a,
.chakra-portal blockquote {
    font-size: inherit;
    font-family: inherit;
    margin: initial;
}

.electric-root hr,
.chakra-portal hr {
    border-bottom: initial;
    margin: initial;
}

.electric-root a:focus,
.chakra-portal a:focus {
    box-shadow: var(--chakra-shadows-outline);
}
`, "",{"version":3,"sources":["webpack://./src/main/js/react/global.css"],"names":[],"mappings":"AAAA;;IAEI,eAAe;AACnB;;AAEA;;;;IAII,SAAS;IACT,kBAAkB;AACtB;;AAEA,gDAAgD;AAChD;;IAEI,uBAAuB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;;;;IAsBI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;;IAEI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;;IAEI,yCAAyC;AAC7C","sourcesContent":[".electric-root,\n.chakra-portal {\n    font-size: 14px;\n}\n\n.electric-root [class^='fa-'],\n.electric-root [class*=' fa-'],\n.chakra-portal [class^='fa-'],\n.chakra-portal [class*=' fa-'] {\n    margin: 0;\n    font-size: inherit;\n}\n\n/* Add font awesome style that's missing in PC */\n.electric-root .svg-inline--fa,\n.chakra-portal .svg-inline--fa {\n    box-sizing: content-box;\n}\n\n.electric-root table,\n.electric-root th,\n.electric-root tr,\n.electric-root td,\n.electric-root ul,\n.electric-root ol,\n.electric-root li,\n.electric-root p,\n.electric-root font,\n.electric-root a,\n.electric-root blockquote,\n.chakra-portal table,\n.chakra-portal th,\n.chakra-portal tr,\n.chakra-portal td,\n.chakra-portal ul,\n.chakra-portal ol,\n.chakra-portal li,\n.chakra-portal p,\n.chakra-portal font,\n.chakra-portal a,\n.chakra-portal blockquote {\n    font-size: inherit;\n    font-family: inherit;\n    margin: initial;\n}\n\n.electric-root hr,\n.chakra-portal hr {\n    border-bottom: initial;\n    margin: initial;\n}\n\n.electric-root a:focus,\n.chakra-portal a:focus {\n    box-shadow: var(--chakra-shadows-outline);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
